site.headSearch = {
	init: function () {
		var $searchToggle = $('#searchToggle'),
			$searchClose = $('#searchClose'),
			$body = $('body');
		$searchToggle.on('click', function() {
			$('#vvSearch').focus();
			$('body').toggleClass('search-open');
		});
		$searchClose.on('click', function() {
			$('body').removeClass('search-open');
		});
		$body.on('keydown', function(e) {
			if(e.key === "Escape") {
				$body.removeClass('search-open');
			}
		});
		$body.on('click', function(e) {
			var $target = $(e.target);
			if (!($target.is('.vvSearch') || $target.parents('.vvSearch').length > 0) &&
				($target.attr('id') !== 'searchToggle' && $target.closest('#searchToggle').length <= 0)) {
				$body.removeClass('search-open');
			}
		});
	}
};
site.inits.push('site.headSearch.init()');
